"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgQuoteRight = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 12c-1.644 0-3-1.334-3-3.023S6.399 6 8 6s3 1.001 3 3.971c0 4.495-1.333 7.171-4 8.029H5c3.976-1.985 3.253-6 3-6zm8 0c-1.644 0-3-1.334-3-3.023S14.399 6 16 6s3 1.001 3 3.971c0 4.495-1.333 7.171-4 8.029h-2c3.976-1.985 3.253-6 3-6z' }))); };
exports.default = SvgQuoteRight;
//# sourceMappingURL=QuoteRight.js.map